import React, { useEffect, useRef } from 'react';

interface GraphTabProps {
    active: boolean;
    graphElement: Element;
}

export function GraphTab({ active, graphElement }: GraphTabProps) {
    const graphTabElementRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!graphElement) {
            throw new Error('Graph to be wrapped not found.');
        }

        // Relocate the existing graph into our tab.
        const graphTabElement = graphTabElementRef.current;
        if (!graphTabElement) return () => {};

        const parent = graphTabElement.parentElement;
        graphTabElement.append(graphElement);

        // On unmount we undo the relocate.
        return () => {
            if (parent) {
                parent.append(graphTabElement);
            }
        };
    }, [graphElement]);

    return <div ref={graphTabElementRef} className={!active ? 'hide' : undefined}></div>;
}
